"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eighteenYearsAgo = exports.calculateDiscount = exports.formatNumberToUSDWithNegativeValues = exports.formatNumberToUSD = exports.roundToTwoDecPlaces = exports.calculatePFR = exports.calculateTerm = exports.calculateDownPmt = exports.calculateTermPmt = exports.calculateDownByPercent = void 0;
var calculateDownByPercent = function (downPercentage, pfr) {
    return (0, exports.roundToTwoDecPlaces)(pfr * downPercentage);
};
exports.calculateDownByPercent = calculateDownByPercent;
var calculateTermPmt = function (pfr, downPayment, term) {
    return (0, exports.roundToTwoDecPlaces)((pfr - downPayment) / term);
};
exports.calculateTermPmt = calculateTermPmt;
var calculateDownPmt = function (pfr, termPayment, term) {
    return (0, exports.roundToTwoDecPlaces)(pfr - (termPayment * term));
};
exports.calculateDownPmt = calculateDownPmt;
var calculateTerm = function (pfr, downPayment, termPayment) {
    return (0, exports.roundToTwoDecPlaces)((pfr - downPayment) / termPayment);
};
exports.calculateTerm = calculateTerm;
var calculatePFR = function (downPayment, termPayment, term) {
    return (0, exports.roundToTwoDecPlaces)(downPayment + (termPayment * term));
};
exports.calculatePFR = calculatePFR;
var roundToTwoDecPlaces = function (num) {
    return (Math.round(num * 100) / 100);
};
exports.roundToTwoDecPlaces = roundToTwoDecPlaces;
var formatNumberToUSD = function (num) {
    if (typeof num === 'number' && !isNaN(num)) {
        var formattedNum = (Math.abs(num)).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        if (num < 0) {
            formattedNum = "(" + formattedNum + ")";
        }
        return formattedNum;
    }
    else { // input was not a number. invalid input. return 0.
        return 0;
    }
};
exports.formatNumberToUSD = formatNumberToUSD;
var formatNumberToUSDWithNegativeValues = function (num) {
    if (typeof num === 'number' && !isNaN(num)) {
        var formattedNum = num.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        return formattedNum;
    }
    else { // input was not a number. invalid input. return 0.
        return 0;
    }
};
exports.formatNumberToUSDWithNegativeValues = formatNumberToUSDWithNegativeValues;
var calculateDiscount = function (pfrAmt, discountAmt) {
    return (0, exports.roundToTwoDecPlaces)(pfrAmt * (1 - (discountAmt / 100)));
};
exports.calculateDiscount = calculateDiscount;
var eighteenYearsAgo = function () {
    var today = new Date();
    return new Date(today.setMonth(today.getMonth() - 12 * 18));
};
exports.eighteenYearsAgo = eighteenYearsAgo;
